/**
 * utils/local-time.js — преобразует UTC-дату в локальное время пользователя.
 * Запускается каждые 100мс, обрабатывает элементы с двумя классами .local-time.local-time-start (data-datetime):
 * записывает локализованное время и снимает только временный класс .local-time-start — базовый .local-time остаётся.
 */
jQuery(document).ready(function () {
    setInterval(function () {
        jQuery(".local-time-start").each(function () {
            // Снимаем маркерный класс — элемент обработан, повторного попадания в селектор не будет
            el.removeClass("local-time-start");

            //Работаем
            let el = jQuery(this);

            let datetime = el.data("datetime");
            if (!datetime) return;

            let date = new Date(datetime);
            if (isNaN(date.getTime())) {
                el.text(datetime);
            } else {
                let offset = -date.getTimezoneOffset();
                let offsetHours = Math.floor(offset / 60);
                let offsetSign = offsetHours >= 0 ? "+" : "-";
                let formatted = date.toLocaleString("ru-RU").replace(", ", " ") + " (UTC" + offsetSign + Math.abs(offsetHours) + ")";
                el.text(formatted);
            }
        });
    }, 100);
});
